<lms-breadcrumb [label]="course.name"></lms-breadcrumb>

<div>
  <div class="courses-body">
    <lms-dynamic-form
      #courseConfigForm
      [action]="'courses.config'"
      [questionsService]="coursesQuestionsService"
      [options]="{
        showSpinnerUponSubmitting: false,
        submitLabel: 'actions.saveChanges',
        disableCard: !styleFormScopes[data.userRole.name]
      }"
      [data]="data"
      (submit)="submit($event)"
      (formSet)="onFormSet($event)"
    >
      <ng-container *ngIf="data && data['course']" form-html>
        <div class="courses-detail__header">
          <div class="courses-detail__name">
            {{ data['course']['title'] ? data['course']['title'] : data['course']['name'] }}
          </div>
          <div *ngIf="data['userRole'].name !== 'hr'" class="courses-detail__config">
            <lms-button-actions *ngIf="hasCourseActions">
              <div class="gl-context-menu__options">
                <ng-container *ngIf="queryClientId && isScormClient">
                  <span
                    *lmsProfileGuard="'courses.scorm'"
                    class="gl-context-menu__options--item"
                    (click)="downloadScormFile()"
                    >{{ items[0].value | translate }}</span
                  >
                </ng-container>
                <ng-container *ngIf="queryClientId && isScormClient">
                  <span
                    *lmsProfileGuard="'courses.download-documents'"
                    class="gl-context-menu__options--item"
                    (click)="modalCourseDocuments.open()"
                    >{{ items[1].value | translate }}</span
                  >
                </ng-container>
                <ng-container *ngIf="canWithdrawCourse">
                  <span
                    class="gl-context-menu__options--item"
                    *lmsProfileGuard="'courses.withdrawCourse'"
                    [ngClass]="{ alert: items[2].value === 'actions.withdrawCourse' }"
                    (click)="onWithdrawCourse()"
                    >{{ items[2].value | translate }}
                  </span>
                </ng-container>
              </div>
            </lms-button-actions>
          </div>
        </div>
        <ng-container *ngIf="canReactivateCourse">
          <div class="courses-detail__draw">
            <span class="text">
              {{ 'courses.config.messageDrawCourse' | translate }}
            </span>
            <a *lmsProfileGuard="'courses.withdrawCourse'" (click)="modalReactivateCourse.open()">
              {{ 'courses.config.reactivateCourse' | translate }}
            </a>
          </div>
        </ng-container>
        <ul class="courses-detail__info">
          <li>
            <div>{{ 'nouns.creator' | translate }}</div>
            <div>{{ data['course']['clientName'] || data['course']['creator'] }}</div>
          </li>
          <li>
            <div>{{ 'nouns.topic' | translate }}</div>
            <div>{{ data['course']['topic'] }}</div>
          </li>
          <li>
            <div>{{ 'nouns.duration' | translate }}</div>
            <div>
              {{
                course.hours || !course.minutes
                  ? (course.hours || 0) +
                    ' ' +
                    (course.hours !== 1 ? ('nouns.hours' | translate) : ('nouns.hour' | translate))
                  : ''
              }}
              {{
                course.minutes
                  ? course.minutes +
                    ' ' +
                    (course.minutes !== 1 ? ('nouns.minutes' | translate) : ('nouns.minute' | translate))
                  : ''
              }}
            </div>
          </li>
          <li>
            <div>{{ 'nouns.credits' | translate }}</div>
            <div>{{ data['course']['credits'] }}</div>
          </li>
        </ul>
        <ul class="courses-detail__info">
          <li>
            <div>{{ 'nouns.languages' | translate }}</div>
            <div>{{ data['course']['languages'] }}</div>
          </li>
        </ul>
        <ul class="courses-detail__info description">
          <li>
            <div class="courses-detail__title label-description">{{ 'nouns.description' | translate }}</div>
            <div>{{ data['course']['description'] }}</div>
          </li>
        </ul>
      </ng-container>
      <gl-button
        color-secondary
        text="{{ 'actions.cancel' | translate }}"
        (onClick)="goBack()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>

  <!-- Confirm course access change modal -->
  <lms-modal #modalClientsPublishSelectorAlert>
    <div class="gl-popup__title">{{ 'courses.publishChange.confirm.title' | translate }}</div>
    <div class="gl-popup__close" (click)="modalClientsPublishSelectorAlert.close()">
      <span class="glicon-close"></span>
    </div>

    <div class="gl-popup__text">{{ 'courses.publishChange.confirm.affectedItineraries' | translate }}</div>
    <div class="gl-popup__text">
      <div *ngFor="let itinerary of itineraries">- {{ itinerary.name }}</div>
    </div>

    <div class="gl-popup__text">{{ 'courses.publishChange.confirm.description' | translate }}</div>

    <div class="gl-popup__buttons">
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="modalClientsPublishSelectorAlert.close()"
      >
      </gl-button>
      <gl-button color-primary [text]="'actions.changeAccess' | translate" (onClick)="confirmUpdate()"></gl-button>
    </div>
  </lms-modal>

  <!-- Confirm withdraw course modal -->
  <lms-modal #modalConfirmWithdrawCourse size="medium">
    <div class="gl-popup__title gap-bottom">{{ 'courses.withdraw.confirm.title' | translate }}</div>
    <div class="gl-popup__close" (click)="modalConfirmWithdrawCourse.close()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__scroll--content">
      <ng-container *ngIf="itinerariesAffectedByWithdrawn.length">
        <div class="gl-popup__text">{{ 'courses.withdraw.confirm.affectedItineraries' | translate }}</div>
        <div class="gl-popup__text">
          <ul class="gl-popup__list">
            <li *ngFor="let itinerary of itinerariesAffectedByWithdrawn">
              {{ itinerary.name + (itinerary.clientName ? '(' + itinerary.clientName + ')' : '') }}
            </li>
          </ul>
        </div>
      </ng-container>

      <div class="gl-popup__text">{{ 'courses.withdraw.confirm.description' | translate }}</div>
      <div class="gl-popup__text">
        <b>{{ 'courses.withdraw.confirm.descriptionBold' | translate }}</b>
      </div>
    </div>
    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalConfirmWithdrawCourse.close()">
      </gl-button>
      <gl-button
        color-primary
        [text]="'actions.withdrawCourse' | translate"
        (onClick)="toggleWithdrawCourse(true)"
      ></gl-button>
    </div>
  </lms-modal>

  <!-- Confirm reactivate course modal -->
  <lms-modal #modalReactivateCourse size="small">
    <div class="gl-popup__title gap-bottom">{{ 'courses.config.confirmReactivation' | translate }}</div>
    <div class="gl-popup__close" (click)="modalReactivateCourse.close()">
      <span class="glicon-close"></span>
    </div>

    <div class="gl-popup__text">{{ 'courses.config.reactivateCourseDescription' | translate }}</div>

    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalReactivateCourse.close()">
      </gl-button>
      <gl-button
        color-primary
        [text]="'courses.config.reactivateCourse' | translate"
        (onClick)="toggleWithdrawCourse(false)"
      ></gl-button>
    </div>
  </lms-modal>

  <!-- Download course documents modal -->
  <lms-modal #modalCourseDocuments size="small">
    <div class="gl-popup__title gap-bottom">{{ 'courses.config.downloadDocumentationTitle' | translate }}</div>
    <div class="gl-popup__text padding-none">
      {{ 'courses.config.downloadDocumentationText' | translate }}
    </div>
    <div class="gl-popup__close" (click)="modalCourseDocuments.close()">
      <span class="glicon-close"></span>
    </div>
    <div class="gl-popup__radioButtons columns-3">
      <div *ngFor="let lang of translationsLangs">
        <gl-radiobutton [options]="[lang]" [value]="selectedLang" (onChange)="selectLang($event)"></gl-radiobutton>
      </div>
    </div>
    <div class="gl-popup__buttons position-static padding-top__none">
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="modalCourseDocuments.close()"
      ></gl-button>
      <gl-button color-primary [text]="'nouns.download' | translate" (onClick)="downloadCourseDocuments()"></gl-button>
    </div>
  </lms-modal>
</div>
